import { registerI18n } from '@videojs/html/cdn/i18n-registry';
import translations from '@videojs/core/i18n/locales/pt-BR';

registerI18n('pt-BR', translations);
